import React, { useEffect, useState } from "react";
import { t } from "ttag";
import { BaseDialog } from '@coolremote/shared';
import OpenGlobalReportButton from "@components/OpenGlobalReportButton";

const ErrorStoreMessage = (props: any) => {
  const [open, setOpen] = useState(false);

  const { className, message } = props;
  const {
    message: messageText,
    buttonText,
    onClick,
    secondaryText,
    mainAction,
    allowDialogClose = true,
    hideReportButton
  } = message || {};

  useEffect(() => {
    if (message) {
      setOpen(true);
    }
  }, [message]);

  const onOkClick = () => {
    setOpen(false);
    onClick && onClick();
  };

  const mainAction1 = () => {
    setOpen(false);
    mainAction && mainAction();
  };

  const closeDialog = () => {
    setOpen(false);
  };

  const handleClose = () => {
    if (allowDialogClose) {
      setOpen(false);
    }
  };

  return (
    <BaseDialog
      className={className}
      open={open}
      onClose={handleClose}
      onConfirm={mainAction ? mainAction1 : onOkClick}
      onCancel={onOkClick}
      title={t`Notification`}
      confirmLabel={buttonText || t`Ok`}
      cancelLabel={secondaryText}
      hideCancel={!secondaryText}
    >
      <p>{messageText}</p>
      {!hideReportButton && (
        <OpenGlobalReportButton closeParent={closeDialog} />
      )}
    </BaseDialog>
  );
};

export default ErrorStoreMessage;
